import React from 'react'
import PageTitle from '../layouts/PageTitle'
import OrderWrap from '../payment/OrderWrap'
import OrderItem from '../payment/OrderItem'
import OrderRow from '../payment/OrderRow'
import PaymentMethods from '../payment/PaymentMethods'
import { AdOrderContext } from '../../contexts/AdOrder'
import Input from '../inputs/Input'
import PaymentMethod from '../payment/PaymentMethod'
import InputWrap from '../inputs/InputWrap'
import CheckboxInput from '../inputs/CheckboxInput'
import PrevStepButton from '../utils/PrevStepButton'
import NextStepButton from '../utils/NextStepButton'
import { getFieldConfig, getNestedFieldConfig } from '../../utils/FieldSettings'

export default function Payment () {
  const { adOrder, fieldSettings, paymentCards } = React.useContext(AdOrderContext)

  const choosePayment = getFieldConfig(fieldSettings, 'choose_payment', {
    title: 'Vælg betalingsmetode'
  })

  const paymentCard = getFieldConfig(fieldSettings, 'choose_payment_card', {
    title: 'Betalingskort eller Mobilepay',
    text: '<p>Vi tager imod en bred vifte af betalingskort; Dankort/VISA-Dankort, MasterCard, Maestro, Visa, Visa Electron</p>'
  })

  const paymentInvoice = getFieldConfig(fieldSettings, 'choose_payment_invoice', {
    title: 'Faktura',
    text: '<p>Til offentlige kunder fremsendes fakturaen elektronisk via EAN-nummer.</p>',
    placeholder: 'Indtast EAN-nr.'
  })

  const acceptTerms = getFieldConfig(fieldSettings, 'accept_terms', {
    title: '<p>Jeg accepterer handelsbetingelser</p>'
  })


  const headline = getNestedFieldConfig(fieldSettings, 'deliver_add', 'headline', {
    title: 'Overskrift på annoncen',
    placeholder: 'Fritekst',
    text: 'Maks. 500 tegn',
  })

  const dateTimePlace = getNestedFieldConfig(fieldSettings, 'deliver_add', 'date_time_and_place', {
    title: 'Dato, tid og sted for begivenheden',
    placeholder: 'Fritekst',
    text: '',
  })

  const websiteLink = getNestedFieldConfig(fieldSettings, 'deliver_add', 'website_link', {
    title: 'Link til hjemmesiden',
    placeholder: 'https://',
    text: '',
  })

  const textForAdd = getNestedFieldConfig(fieldSettings, 'deliver_add', 'text_for_add', {
    title: 'Tekst til annoncen og evt. øvrige bemærkninger',
    placeholder: 'Fritekst',
    text: '',
  })

  return (
    <>
      <PageTitle step={2}/>

      <OrderWrap>
        {!adOrder.delivered_by_customer && <>
          <OrderRow>
            <OrderItem title={headline.title}>
              {adOrder.headline}
            </OrderItem>
          </OrderRow>
          <OrderRow>
            <OrderItem title={dateTimePlace.title}>
              {adOrder.date_time_and_place}
            </OrderItem>
          </OrderRow>
          <OrderRow>
            <OrderItem title={websiteLink.title}>
              {adOrder.url}
            </OrderItem>
          </OrderRow>
          <OrderRow>
            <OrderItem title={textForAdd.title}>
              {adOrder.content}
            </OrderItem>
          </OrderRow>
        </>}
        <OrderRow>
          <OrderItem title={'Billede'}>
            <img src={adOrder.image} alt={'dit uploadede billede'}/>
          </OrderItem>
        </OrderRow>
      </OrderWrap>

      <PaymentMethods title={choosePayment.title}>
        <PaymentMethod
          value={'dibs'}
          label={paymentCard.title}
          description={paymentCard.text?.replace(/<\/?p>/g, '')}
          icon={paymentCards}
        />
        <PaymentMethod
          value={'ean'}
          label={paymentInvoice.title}
          description={paymentInvoice.text?.replace(/<\/?p>/g, '')}
        >
          <Input
            name={'ean'}
            placeholder={paymentInvoice.placeholder}
            subobj={'payment'}
            pattern={'/\\d{13}/'}
          />
        </PaymentMethod>

      </PaymentMethods>
      <InputWrap>
        <div className={'ad-next-step between spacing'}>
          <CheckboxInput
            label={`${acceptTerms.title?.replace(/<\/?p>/g, '')}<span class="input-asterisk" style="color: #9A0000;">*</span>`}
            value={true}
            toggleAble={true}
            name={'accept'}
            subobj={'payment'}
          />
        </div>
        <div className="ad-next-step between spacing">
          <PrevStepButton label="Tilbage" style="outline-dark arrow-flipped" />
          <NextStepButton label="Bekræft bestilling" style="secondary" />
        </div>
      </InputWrap>
    </>
  )
}